import { render, staticRenderFns } from "./AssetProfileModal.vue?vue&type=template&id=46b0e8f7&scoped=true"
import script from "./AssetProfileModal.vue?vue&type=script&lang=js"
export * from "./AssetProfileModal.vue?vue&type=script&lang=js"
import style0 from "./AssetProfileModal.vue?vue&type=style&index=0&id=46b0e8f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b0e8f7",
  null
  
)

export default component.exports